/*global Snap*/
require('./index.html')
require('./images/logo.png')
require('./images/logo-chinese.png')
require('./images/logo-inverse.png')
require('./images/logo-chinese-inverse.png')
require('./images/quote-left-black.png')
require('./images/quote-right-black.png')
require('./images/quote-left-white.png')
require('./images/quote-right-white.png')
var slideImg1 = require('./images/EU-Capital-Lake-BG.jpg')
var slideImg2 = require('./images/EU-Capital-Field-BG.jpg')
var slideImg3 = require('./images/EU-Capital-Tree-BG.jpg')
require('./images/kelvin.png')
var slideImages = [slideImg1, slideImg2, slideImg3]
var $ = require('jquery')
require('jquery-form-validator')
var ScrollReveal = require('ScrollReveal')
require('Snap')

// IE detection for SVG animation
if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
  $('html').addClass('ie')
}

var sr = ScrollReveal()

// Add class to <html> if ScrollReveal is supported
if (sr.isSupported()) {
  document.documentElement.classList.add('sr')
}

$(document).ready(function () {
  sr.reveal('.logo', {
    origin: 'top',
    distance: '100%',
    duration: 1500,
    delay: 500,
    easing: 'ease-in-out'
  })

  sr.reveal('.slide__title', {
    duration: 1500
  })

  sr.reveal('.slide__text', {
    duration: 1500
  })

  sr.reveal('.value__title', {
    duration: 1500
  })

  sr.reveal('.value__text', {
    duration: 1500
  })

  sr.reveal('#about .slick-prev', {
    origin: 'left',
    distance: '100%',
    duration: 1500
  })

  sr.reveal('#about .slick-next', {
    origin: 'right',
    distance: '100%',
    duration: 1500
  })

  sr.reveal('.personnel__title', {
    duration: 1500
  })

  sr.reveal('.personnel__text', {
    duration: 1500
  })

  sr.reveal('.personnel__image', {
    duration: 1500,
    origin: getViewportWidth() > 768 ? 'left' : 'bottom',
    distance: getViewportWidth() > 768 ? '50%' : '20px'
  })

  sr.reveal('.clients__title', {
    duration: 1500
  })

  sr.reveal('.clients__text', {
    duration: 1500
  })

  // sr.reveal('.clients__listItem', {
  //   duration: 1500
  // })

  sr.reveal('.clients__listText', {
    duration: 1500
  })
})

$(window).on('load resize orientationchange', function () {
  // store the quote mark's transform position in the data
  $('.quote__mark--left').each(function (index, el) {
    $(el).data('position', el.getBoundingClientRect().left + el.getBoundingClientRect().width)
  })
})

function quoteReveal (slick, index, action) {
  var $slide = $(slick.$slides.get(index))
  var $quoteText = $slide.find('.quote__text')
  var $quoteCite = $slide.find('.quote__cite')
  var $quoteMarkLeft = $slide.find('.quote__mark--left')
  var $quoteMarkRight = $slide.find('.quote__mark--right')

  if (action === 'show') {
    $quoteText.addClass('quote__text--visible')
    $quoteCite.addClass('quote__cite--visible')
    $quoteMarkLeft.addClass('quote__mark--visible')
    $quoteMarkRight.addClass('quote__mark--visible')
  } else if (action === 'hide') {
    $quoteText.removeClass('quote__text--visible')
    $quoteCite.removeClass('quote__cite--visible')
    $quoteMarkLeft.removeClass('quote__mark--visible')
    $quoteMarkRight.removeClass('quote__mark--visible')
  }
}

$('.top .slider .slide').each(function (index, slide) {
  var imgPath = slideImages[index]
  var $slide = $(slide)
    // make slide not visible
  $slide.addClass('slide--loading')
  $('<img/>').attr('src', imgPath).load(function () {
    $(this).remove() // prevent memory leak
      // set as background image
    $slide.css('background-image', 'url(' + imgPath + ')')
      // fade the slide in
    setTimeout(function () {
      $slide.removeClass('slide--loading')
    }, 500)
  })
})

$(document).ready(function () {
  // Init slider
  $('.top .slider').on('init', function (evt, slick) {
    setTimeout(function () {
      quoteReveal(slick, 0, 'show')
        // add class so it doesn't animate again
      $('.quote__mark').addClass('quote__mark--animated')
    }, 1500)
  }).slick({
    autoplay: true,
    autoplaySpeed: 15000,
    arrows: false,
    fade: true
  }).on('beforeChange', function (evt, slick, currentSlide, nextSlide) {
    quoteReveal(slick, currentSlide, 'hide')
  }).on('afterChange', function (evt, slick, currentSlide) {
    quoteReveal(slick, currentSlide, 'show')
  })
})

function nextSlide () {
  $('.top .slider').slick('slickNext')
}

// change slide when image is clicked
$('.top .slider').on('click', function (evt) {
  nextSlide()
})

$('.about .slider').slick({
  autoplay: true,
  autoplaySpeed: 30000,
  dots: true,
  fade: true,
  prevArrow: '<button type="button" class="slick-prev"><span class="slider__arrowText">Previous</span></button>',
  nextArrow: '<button type="button" class="slick-next"><span class="slider__arrowText">Next</span></button>'
})

// Set the height of slider using javascript
$(window).on('load resize orientationchange', function (evt) {
  var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
  $('.top .slide').height(viewportHeight)
})

// Smooth Scroll within page
// https://css-tricks.com/snippets/jquery/smooth-scrolling/
$('a[href*="#"]:not([href="#"])').click(function () {
  if (window.location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && window.location.hostname === this.hostname) {
    var target = $(this.hash)
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']')
    if (target.length) {
      // special handling for #about, to scroll to nav if small screen instead
      if (target.get(0).id === 'about' && $(this).hasClass('top__scrollDown')) {
        if (getViewportWidth() < 768) {
          target = $('.nav--top')
        }
      }

      $('html, body').animate({
        scrollTop: target.offset().top
      }, 1000)
      return false
    }
  }
})

$('.jsExpandFooter').on('click', function (evt) {
  evt.preventDefault()
    // toggle expansion of the footer
  $('.footer').toggleClass('footer--show')
  $('.contactToggle').toggleClass('contactToggle--collapse')
})

function setFooterTransform () {
    // set the footer's transform
  var contactFormDivHeight = $('.contact').outerHeight()
  var visibleFooterHeight = $('.footer').outerHeight() - contactFormDivHeight

  $('.footer').css({
    '-webkit-transform': 'translateY(' + contactFormDivHeight + 'px)',
    '-moz-transform': 'translateY(' + contactFormDivHeight + 'px)',
    '-ms-transform': 'translateY(' + contactFormDivHeight + 'px)',
    '-o-transform': 'translateY(' + contactFormDivHeight + 'px)',
    'transform': 'translateY(' + contactFormDivHeight + 'px)'
  })

  $('.content').css('padding-bottom', visibleFooterHeight + 'px')
}

$(window).on('load resize orientationchange', setFooterTransform)

function getViewportWidth () {
  return Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
}

// Javascript animate svg
// set svg css animation to none and control using javascript
var $investment = $('#Investment_Selection')
var $risk = $('#Big_Picture_Risk_Management')
var $shield = $('#shield')
var $singlePoint = $('#Single_Point')
var $learning = $('#Continuous_Learning')
var $costs = $('#Transparency_of_costs')
// only use javascript to animate if it's IE
if ($('html').hasClass('ie')) {
  $investment.find('rect').css('animation', 'none')
  $investment.find('line').css('animation', 'none')
  $risk.css('animation', 'none')
  $shield.css('animation', 'none')
  $singlePoint.find('path').css('animation', 'none')
  $learning.find('path, line').css('animation', 'none')
  $costs.find('g').css('animation', 'none')
}

// animate investment group
// setup svgs for animation
var investmentSvgs = []
$investment.find('.jsSnapGroup').each(function (index, group) {
  var $group = $(group)
  var elements = []
  var rect = $group.find('rect').get(0)
  elements.push(Snap(rect))
  $group.find('line').each(function (index, line) {
    elements.push(Snap(line))
  })
  investmentSvgs.push(elements)
})

var investmentTimeouts = []

function animateInvestmentGroup (rectSvg, line1Svg, line2Svg, index) {
  var timeoutId = setTimeout(function () {
    rectSvg.animate({strokeDashoffset: 0}, 500, null, function () {
      line1Svg.animate({strokeDashoffset: 0}, 500)
      line2Svg.animate({strokeDashoffset: 0}, 500)
    })
  }, 500 * index)

  investmentTimeouts.push(timeoutId)
}

function animateInvestment () {
  // clear all timeouts
  for (var i = 0; i < investmentTimeouts.length; i++) {
    clearTimeout(investmentTimeouts[i])
  }

  // stop all animations
  for (var j = 0; j < investmentSvgs.length; j++) {
    for (var k = 0; k < investmentSvgs[j].length; k++) {
      investmentSvgs[j][k].stop()
      // set the starting lengths
      var dashArrayLength = investmentSvgs[j][k].attr('stroke-dasharray')
      investmentSvgs[j][k].attr('strokeDashoffset', dashArrayLength)
    }
  }

  // animate all items by groups
  for (var l = 0; l < investmentSvgs.length; l++) {
    for (var m = 0; m < investmentSvgs[l].length; m++) {
      if (investmentSvgs[l][m].type === 'rect') {
        var rectSvg = investmentSvgs[l][m]
        var line1Svg = investmentSvgs[l][m + 1]
        var line2Svg = investmentSvgs[l][m + 2]
      } else {
        break
      }

      animateInvestmentGroup(rectSvg, line1Svg, line2Svg, l)
    }
  }
}

// animate risk
function animateRisk () {
  var risk = Snap($risk.get(0))
  var dashArrayLength = parseInt(risk.attr('stroke-dasharray'))
  Snap.animate(dashArrayLength, 0, function (val) {
    risk.attr({
      strokeDashoffset: val
    })
  }, 2000)
}

// animate shield
function animateShield () {
  var shield = Snap($shield.get(0))
  var dashArrayLength = parseInt(shield.attr('stroke-dasharray'))
  Snap.animate(dashArrayLength, dashArrayLength * 2, function (val) {
    shield.attr({
      strokeDashoffset: val
    })
  }, 2000)
}

// animate single point of contact
function animateSinglePoint () {
  var $paths = $singlePoint.find('path')
  $paths.each(function (index, path) {
    var pathSvg = Snap(path)
    var $path = $(path)
    var dashArrayLength = parseInt(pathSvg.attr('stroke-dasharray'))
    if ($path.hasClass('outer')) {
      pathSvg.animate({strokeDashoffset: 0}, 2000)
      Snap.animate(dashArrayLength, 0, function (val) {
        pathSvg.attr({
          strokeDashoffset: val
        })
      }, 2000)
    }
    if ($path.hasClass('inner')) {
      pathSvg.animate({strokeDashoffset: parseInt(pathSvg.attr('stroke-dasharray')) * 2}, 2000)
      Snap.animate(dashArrayLength, dashArrayLength * 2, function (val) {
        pathSvg.attr({
          strokeDashoffset: val
        })
      }, 2000)
    }
  })
}

// animate continuous learning
function animateLearning () {
  $learning.find('path, line').each(function (index, el) {
    var svg = Snap(el)
    var $el = $(el)
    var dashArrayLength = parseInt(svg.attr('stroke-dasharray'))
    if ($el.hasClass('outer') || $el.hasClass('middle')) {
      Snap.animate(dashArrayLength, dashArrayLength * 2, function (val) {
        svg.attr({
          strokeDashoffset: val
        })
      }, 2000)
    } else {
      Snap.animate(dashArrayLength, 0, function (val) {
        svg.attr({
          strokeDashoffset: val
        })
      }, 2000)
    }
  })
}

// animate transparency of costs
var costsTimeouts = []
var costsSvgs = []
var sequence = ['bottom', 'middle', 'top']
// setup svgs for animation
$.each(sequence, function (index, className) {
  var $group = $costs.find('g.' + className)
  var elements = []
  $group.find('line').each(function (index, line) {
    var lineSvg = Snap(line)
    elements.push(lineSvg)
  })
  costsSvgs.push(elements)
})

function animateCostsGroup (group, index) {
  // animate each group of line group by group
  var timeout = setTimeout(function () {
    $(group).find('line').each(function (lineIndex, line) {
      var lineSvg = Snap(line)
      lineSvg.animate({strokeDashoffset: 0}, 1000)
      // var dashArrayLength = parseInt(lineSvg.attr('stroke-dasharray'))
      // Snap.animate(dashArrayLength, 0, function (val) {
      //   lineSvg.attr({
      //     strokeDashoffset: val
      //   })
      // }, 1000)
    })
  }, 500 * index)
  costsTimeouts.push(timeout)
}

function animateCosts () {
  // clear all timeouts
  for (var i = 0; i < costsTimeouts.length; i++) {
    clearTimeout(costsTimeouts[i])
  }

  // stop all animations
  for (var j = 0; j < costsSvgs.length; j++) {
    for (var k = 0; k < costsSvgs[j].length; k++) {
      costsSvgs[j][k].stop()
      // set the starting lengths
      var dashArrayLength = costsSvgs[j][k].attr('stroke-dasharray')
      costsSvgs[j][k].attr('strokeDashoffset', dashArrayLength)
    }
  }

  // set all lines length to initial for animation
  $costs.find('line').each(function (index, line) {
    var $line = $(line)
    var dashArrayLength = parseInt($line.css('stroke-dasharray'))
    $line.css('stroke-dashoffset', dashArrayLength)
  })
  $.each(sequence, function (index, className) {
    var group = $costs.find('g.' + className).get(0)
    animateCostsGroup(group, index)
  })
}

function animateIESvg (id) {
  switch (id) {
    case 'Investment_Selection':
      animateInvestment()
      break
    case 'Big_Picture_Risk_Management':
      animateRisk()
      break
    case 'shield':
      animateShield()
      break
    case 'Single_Point':
      animateSinglePoint()
      break
    case 'Continuous_Learning':
      animateLearning()
      break
    case 'Transparency_of_costs':
      animateCosts()
      break
    default: // do nothing
      break
  }
}

// Animate svg icons when scrolled into view
function isScrolledIntoView (elem) {
  var docViewTop = $(window).scrollTop()
  var docViewBottom = docViewTop + $(window).height()

  var elemTop = $(elem).offset().top
  var elemMiddle = elemTop + $(elem).height() / 2

  return ((elemMiddle <= docViewBottom) && (elemTop >= docViewTop))
}

// but first hide the icons
$('.valueCell__icon').addClass('valueCell__icon--init')

var numOfIcons = $('.valueCell__icon').length
$(window).on('load scroll', function (evt) {
  var numOfIconsInView = $('.valueCell__icon--animated').length
  numOfIconsInView += $('.valueCell__icon--animateAgain').length
  if (numOfIconsInView < numOfIcons) {
    $('.valueCell__icon').each(function (index, el) {
      if (isScrolledIntoView(el)) {
        var $el = $(el)
        // show the icons
        $el.removeClass('valueCell__icon--init')
        // animate the icons
        if (!$el.hasClass('valueCell__icon--animated') && !$el.hasClass('valueCell__icon--animateAgain')) {
          $(el).addClass('valueCell__icon--animated')

          // for IE, animate using javascript
          if ($('html').hasClass('ie')) {
            // if the element is alr animated, then don't do anything
            // find out what icon is scrolled into view
            animateIESvg(el.id)
          }
        }
      }
    })
  }
})

// Reset svg animation on mouse leave
function resetIconAnimation ($icon) {
  if ($icon.hasClass('valueCell__icon--animated')) {
    $icon.removeClass('valueCell__icon--animated').addClass('valueCell__icon--animateAgain')
  } else {
    $icon.removeClass('valueCell__icon--animateAgain').addClass('valueCell__icon--animated')
  }
  // ie animate using svg
  if ($('html').hasClass('ie')) {
    animateIESvg($icon.get(0).id)
  }
}

$('.valueCell').on('touchstart', function (evt) {
  // add class to mark that this is a touch event
  $(this).addClass('jsTouch')
})

$('.valueCell').on('mouseenter', function (evt) {
  var $this = $(this)
  if ($this.hasClass('jsTouch')) {
    // do nothing allow click to add the class
  } else {
    // this is a mouse event
    $this.addClass('jsMouse')
    $this.addClass('valueCell--expand')
  }
})

$('.valueCell').on('mouseleave', function (evt) {
  var $this = $(this)
  if ($this.hasClass('jsMouse')) {
    $this.removeClass('valueCell--expand jsMouse')
    // reset animation on removal of expand class
    var $icon = $(this).find('.valueCell__icon')
    resetIconAnimation($icon)
  }
})

function toggleValueCellState (target, expand) {
  // close all cells and reset animation for those that are collapsed
  $('.valueCell').each(function (index, cell) {
    var $cell = $(cell)
    if ($cell.hasClass('valueCell--expand')) {
      $cell.removeClass('valueCell--expand')
      var $icon = $cell.find('.valueCell__icon')
      resetIconAnimation($icon)
    }
  })
  if (expand === true) {
    $(target).addClass('valueCell--expand')
  }
}

$('.valueCell').on('click', function (evt) {
  var $this = $(this)
  if ($this.hasClass('jsTouch')) {
    if ($this.hasClass('valueCell--expand')) {
      toggleValueCellState(this, false)
    } else {
      toggleValueCellState(this, true)
    }
    $this.removeClass('jsTouch')
  }
  // do nothing for jsMouse
})

// animate ticks
function animateTick (el) {
  var tickCircle = Snap($(el).find('.clients__tickCircle').get(0))
  var $tickMark = $(el).find('.clients__tickMark')
  var dashArrayLength = parseInt(tickCircle.attr('stroke-dasharray'))
  Snap.animate(dashArrayLength, 0, function (val) {
    tickCircle.attr({
      strokeDashoffset: val
    })
  }, 500, function animateMark () {
    $tickMark.css({fill: 'black', 'fill-opacity': 1, transition: 'fill 1s'})
  })
}

// first hide the tick marks
$('.clients__tick').addClass('clients__tick--init')
var numOfTicks = $('.clients__tick').length
$(window).on('load scroll', function (evt) {
  var numOfTicksInView = $('.clients__tick--animated').length
  numOfTicksInView += $('.clients__tick--animateAgain').length
  if (numOfTicksInView < numOfTicks) {
    $('.clients__tick').each(function (index, el) {
      if (isScrolledIntoView(el)) {
        var $el = $(el)
        // show the icons
        $el.removeClass('clients__tick--init')
        // animate the icons
        if (!$el.hasClass('clients__tick--animated')) {
          $(el).addClass('clients__tick--animated')

          // for IE, animate using javascript
          if ($('html').hasClass('ie')) {
            // if the element is alr animated, then don't do anything
            // find out what icon is scrolled into view
            animateTick(el)
          }
        }
      }
    })
  }
})

// Open Terms
$('.menuItem__link--terms, .terms__close').on('click', function (evt) {
  evt.preventDefault()
  $('.terms').toggleClass('terms--visible')
})

function capitalizeFirstLetter (string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

function getNormalizedLocale (locale) {
  var lowercase = locale.toLowerCase().replace('-', '')
  return capitalizeFirstLetter(lowercase)
}

// Language toggling
$('.language__link').on('click', function (evt) {
  evt.preventDefault()

  // toggle states of all language links
  var $this = $(this)
  $('.language__link').removeClass('language__link--active')
  $(this).addClass('language__link--active')

  // toggle the text
  var language = $this.data('language')

  $('.jsLangText').addClass('jsHidden')
  $('.jsLangText[data-language=' + language + ']').removeClass('jsHidden')

  // toggle the placeholders and value
  var lowerCaseLang = language.toLowerCase().replace('-', '')
  var capitalCaseLang = capitalizeFirstLetter(lowerCaseLang)
  $('[data-value-' + lowerCaseLang + ']').each(function (index, el) {
    var $el = $(el)
    var value = $el.data('value' + capitalCaseLang)
    $el.val(value)
  })
  $('[data-placeholder-' + lowerCaseLang + ']').each(function (index, el) {
    var $el = $(el)
    var placeholder = $el.data('placeholder' + capitalCaseLang)
    $el.attr('placeholder', placeholder)
  })

  // Change the quote marks positioning
  var $quoteMarks = $('.quote__mark')
  var languages = $('.language__link').map(function (index, el) {
    return $(el).data('language').toLowerCase().replace('-', '')
  })
  for (var i = 0; i < languages.length; i++) {
    $quoteMarks.removeClass('quote__mark--' + languages[i])
  }
  $quoteMarks.addClass('quote__mark--' + lowerCaseLang)

  // hide all contact form error message
  $('.form-error').remove()

  // change html class for styling
  var $html = $('html')
  for (var j = 0; j < languages.length; j++) {
    $html.removeClass(languages[j])
  }
  $html.addClass(lowerCaseLang)

  // change personnel class for styling
  var $personnel = $('.personnel')
  $personnel.attr('class', 'personnel')
  $personnel.addClass('personnel--' + language)

  // change header logo
  var $logos = $('.logo__img')
  // hide both logos
  $logos.addClass('jsHidden')

  // show the logo that matches the langauge
  $logos.each(function (index, el) {
    var $el = $(el)

    if ($el.data('language') === language) {
      $el.removeClass('jsHidden')
    }
  })

  // change footer logo
  var $footerLogos = $('.details__logo')
  // hide both logos
  $footerLogos.addClass('jsHidden')

  // show the logo that matches the langauge
  $footerLogos.each(function (index, el) {
    var $el = $(el)

    if ($el.data('language') === language) {
      $el.removeClass('jsHidden')
    }
  })
})

function hideMessages () {
  $('.contactForm__message--success').removeClass('contactForm__message--visible')
  $('.contactForm__message--error').removeClass('contactForm__message--visible')
}

function showSuccessMessage () {
  // $('.contactForm__message--success').addClass('contactForm__message--visible')
  // $('.contactForm__message--error').removeClass('contactForm__message--visible')
  $('.contact__message').addClass('contact__message--visible')
}

function showErrorMessage () {
  $('.contactForm__message--error').addClass('contactForm__message--visible')
  $('.contactForm__message--success').removeClass('contactForm__message--visible')
}

// init validation
$.validate({
  onElementValidate: function (isValid, $el, $form, errMsg) {
    var language = 'en-US'
    if ($('.language__link--active').data('language')) {
      language = getNormalizedLocale($('.language__link--active').data('language'))
    }
    if (isValid === false) {
      setTimeout(function () {
        var errorMsg = $el.data('error' + language)
        $el.siblings('.form-error').text(errorMsg)
      }, 1)
    }
    // change the height of the footer
    setFooterTransform()
    $('.contactForm__success').removeClass('.contactForm__success--visible')

    // remove form messages
    hideMessages()
  },

  onSuccess: function ($form) {
    // disable the form
    $('.contactForm input, .contactForm textarea, .contactForm button').prop('disabled', true)
    $.ajax({
      url: './mail.php',
      type: 'POST',
      dataType: 'json',
      data: {
        name: $form.find('input[name="name"]').val(),
        email: $form.find('input[name="email"]').val(),
        phone: $form.find('input[name="phone"]').val(),
        message: $form.find('textarea').val()
      },
      success: function (response) {
        console.log(response)
        if (response.success) {
          showSuccessMessage()
        } else {
          showErrorMessage()
        }
      },
      error: function (response) {
        console.log(response)
        showErrorMessage()
      },
      complete: function (response) {
        console.log(response)
        // enable the form
        $('.contactForm input, .contactForm textarea, .contactForm button').prop('disabled', false)
      }
    })
  }
})

$('form').on('submit', function (evt) {
  evt.preventDefault()
})

// Close thank you message
$('.contact__close').on('click', function (evt) {
  evt.preventDefault()
  $('.contact__message').removeClass('contact__message--visible')
})



/*****************
 ** WEBPACK FOOTER
 ** ./src/index.js
 ** module id = 0
 ** module chunks = 0
 **/